module.exports = __webpack_public_path__ + "img/hero.27b399c7.png";